var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$store.state.stylistsAccount.loading)?_c('v-container',{staticClass:"px-0 px-sm-3 pt-0"},[_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }